import { useState } from 'react';

/** Chili Piper supports embedding round-robin booking links directly in an iframe. */
const WalkthroughScheduling = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mt-8 text-center">
      <p className="mx-auto mb-5 max-w-[56ch] text-pretty text-base text-gray-600 sm:text-sm dark:text-gray-300">
        See how ChiroUp simplifies documentation, scheduling, and billing. Schedule a personalized
        walkthrough with our team.
      </p>
      <button
        type="button"
        aria-expanded={open}
        aria-controls="walkthrough-scheduling"
        onClick={() => setOpen(value => !value)}
        className="rounded-lg bg-primary-600 px-4 py-3 text-base font-semibold text-white hover:bg-primary-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
      >
        {open ? 'Close scheduling' : 'Schedule Your Personal Walkthrough'}
      </button>
      {open && (
        <section
          id="walkthrough-scheduling"
          aria-label="Schedule your personal walkthrough"
          className="mt-6"
        >
          <iframe
            src="https://chiroup.chilipiper.com/round-robin/chiroup-walkthrough"
            title="ChiroUp personal walkthrough scheduling"
            className="h-[48rem] w-full rounded-lg border-0 bg-white"
          />
        </section>
      )}
    </div>
  );
};

export default WalkthroughScheduling;
